import * as React from 'react';

import { context } from './context';
import { TContext } from '../types/context';

export function useContext(): TContext {
  return React.useContext(context);
}
